import { Directive, ElementRef, HostListener, Renderer2, inject } from '@angular/core';

@Directive({
  selector: '[appRefreshSpin]',
  standalone: true,
})
export class RefreshSpinDirective {
  private el = inject(ElementRef<HTMLElement>);
  private renderer = inject(Renderer2);

  private readonly spinClass = 'refresh-spin';

  @HostListener('click')
  onClick(): void {
    const host = this.el.nativeElement;

    this.renderer.removeClass(host, this.spinClass);
    void host.offsetWidth;
    this.renderer.addClass(host, this.spinClass);
  }
}
